<template>
    <v-autocomplete v-model="selectedDefaultAppointments" :items="displayDefaultAppointments" :loading="isLoading" :disabled="disabled" item-value="id" clear-icon="far fa-times-circle" :search-input.sync="search" @focus="$emit('focus')" :menu-props="{ bottom: true, offsetY: true }" @change="$emit('input', selectedDefaultAppointments)" :multiple="multiple" :label="label" :placeholder="placeholder" :error-messages="errors" :hide-details="!failed" no-data-text="Commencez à taper pour lancer une recherche" :class="{ 'flex-grow-0': flexGrow0 }" color="app-blue" background-color="white" return-object no-filter outlined clearable dense>
        <template v-slot:selection="data">
            <v-chip v-if="data.index === 0" small label>
                {{ data.item.subject }}
            </v-chip>

            <span v-if="data.index === 1" class="grey--text text-caption">
                (+{{ selectedDefaultAppointments.length - 1 }} autres)
            </span>
        </template>

        <template v-slot:prepend>
            <slot name="prepend" />
        </template>

        <template v-slot:item="{ item }">
            <v-list-item-content>
                <v-list-item-title>
                    {{ item.subject }}
                </v-list-item-title>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    name: 'AppointmentDefaultAutocomplete',

    props: {
        value: { required: true },
        label: { type: String },
        placeholder: { type: String },
        disabled: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false },
        flexGrow0: { type: Boolean, default: false },
        noDynamicSearch: { type: Boolean, default: false },
        errors: { type: Array },
        failed: { type: Boolean, default: false },
        initDefaultAppointments: { type: Array }
    },

    data: () => ({
        selectedDefaultAppointments: null,
        appointments: [],
        displayDefaultAppointments: [],
        isLoading: false,
        search: null,
        searchTimeout: null
    }),

    watch: {
        value() {
            this.selectedDefaultAppointments = this.value;
        },

        search(search) {
            if (this.noDynamicSearch) {
                if (typeof search !== 'string' || search.length.length < 3) {
                    this.displayDefaultAppointments = this.appointments;
                } else {
                    this.displayDefaultAppointments = this.appointments.filter((p) => {
                        return p.subject.toLowerCase().includes(search.toLocaleLowerCase());
                    });
                }
                return;
            }

            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                if (typeof search !== 'string' || search.length.length < 3) {
                    return;
                }
                if (this.isLoading) {
                    return;
                }

                this.isLoading = true;
                const query = {
                    limit: 5,
                    quickSearch: search
                };
                this.fetch(query);
            }, 500);
        },

        initDefaultAppointments() {
            this.displayDefaultAppointments = this.initDefaultAppointments;
        }
    },

    computed: {
        noDataText() {
            if (this.noDynamicSearch) {
                return 'Aucun programme disponible';
            } else {
                return 'Commencez à taper pour lancer une recherche';
            }
        }
    },

    methods: {
        async fetch(query = {}) {
            try {
                this.isLoading = true;
                query.include = 'categories';
                const { defaultAppointments } = await this.repos.appointments.getDefaultAppointments(query);
                this.defaultAppointments = defaultAppointments;
                this.displayDefaultAppointments = defaultAppointments;
            } catch (err) {
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },

        reset() {
            this.selectedDefaultAppointments = [];
        }
    },

    created() {
        this.selectedDefaultAppointments = this.value;
        if ((Array.isArray(this.selectedDefaultAppointments) && this.selectedDefaultAppointments.length > 0) || typeof this.selectedDefaultAppointments === 'number') {
            const defaultAppointments = Array.isArray(this.selectedDefaultAppointments) ? this.selectedDefaultAppointments : [this.selectedDefaultAppointments];
            this.fetch({ defaultAppointments });
        }
        if (this.initDefaultAppointments) {
            this.displayDefaultAppointments = this.initDefaultAppointments;
        }
    }
};
</script>